var _title, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEnlarge = function SvgEnlarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }), _title || (_title = /*#__PURE__*/React.createElement("title", null, "enlarge")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 19.031V4.968H3v14.063zM21 3q.797 0 1.406.609t.609 1.406v13.969q0 .797-.609 1.406T21 20.999H3q-.797 0-1.406-.609t-.609-1.406V5.015q0-.797.609-1.406T3 3zm-6.984 12.984L12 18.515l-2.016-2.531zM6 9.984v4.031l-2.484-2.016zm12 0L20.484 12 18 14.016zm-6-4.5 2.016 2.531H9.985z"
  })));
};
export default SvgEnlarge;